import { useMemo } from 'react';
import { history } from 'umi';

/**
 * 解析 URL 查询参数的 hook
 * @param paramNames 需要解析的参数名数组
 * @returns 解析后的参数对象
 */
export const useQueryParams = <T extends Record<string, any>>(paramNames: (keyof T)[]) => {
  const { query } = history.location;

  const getQueryString = (val?: any) => Array.isArray(val) ? val[0] : val;

  const parseQueryParam = (paramName: keyof T): any => {
    const raw = getQueryString(query?.[paramName as string]);

    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  };

  const parsedParams = useMemo(() => {
    const result: Partial<T> = {};

    paramNames.forEach(paramName => {
      result[paramName] = parseQueryParam(paramName);
    });

    return result;
  }, [query, paramNames]);

  return parsedParams;
};
